/**
 * Mount Preact Drive side pages when #drive-side-preact-root is present.
 * Views: trash | shares | shared_with_me | webdav | statistics
 */

import { render, h } from 'preact'
import { TrashPage } from '../../components/drive/TrashPage.jsx'
import { SharesPage } from '../../components/drive/SharesPage.jsx'
import { SharedWithMePage } from '../../components/drive/SharedWithMePage.jsx'
import { WebdavPage } from '../../components/drive/WebdavPage.jsx'
import { StatisticsPage } from '../../components/drive/StatisticsPage.jsx'

const PAGES = {
  trash: TrashPage,
  shares: SharesPage,
  shared_with_me: SharedWithMePage,
  webdav: WebdavPage,
  statistics: StatisticsPage
}

let sideRoot = null

function readProps(root) {
  const raw = root.dataset.driveProps
  if (!raw) return {}
  try {
    return JSON.parse(raw)
  } catch (e) {
    console.error('[drive] invalid data-drive-props on side root', e)
    return {}
  }
}

/**
 * @returns {boolean} true when a side page was mounted (browse should skip)
 */
export function mountDriveSidePage() {
  const root = document.getElementById('drive-side-preact-root')
  if (!root) return false

  if (root.dataset.driveSideMounted === '1' && sideRoot === root) return true

  unmountDriveSidePage()

  const view = root.dataset.driveView
  const Page = PAGES[view]
  if (!Page) {
    console.error('[drive] unknown data-drive-view', view)
    return false
  }

  const props = readProps(root)
  render(h(Page, { props }), root)
  root.dataset.driveSideMounted = '1'
  sideRoot = root
  return true
}

export function unmountDriveSidePage() {
  if (sideRoot) {
    render(null, sideRoot)
    delete sideRoot.dataset.driveSideMounted
    sideRoot = null
  }
  const orphan = document.getElementById('drive-side-preact-root')
  if (orphan) delete orphan.dataset.driveSideMounted
}
